import Button from "app/components/button/button";
import CircleLoader from "app/components/loader/CircleLoader";
import { useTheme } from "app/shared";
import React, { useState } from "react";
import styles from "./leaderboard.module.scss";

interface UserWithCompleteQuestXp {
  address: string;
  xp_mul: number;
  ref_xp?: never;
}

interface UserWithRefXp {
  address: string;
  ref_xp: number;
  xp_mul?: never;
}

type User = UserWithCompleteQuestXp | UserWithRefXp;

interface LeaderboardProps {
  users: User[];
  isLoading: boolean;
  isRef: boolean;
}

const Leaderboard: React.FC<LeaderboardProps> = ({
  users = [],
  isLoading,
  isRef,
}) => {
  const [visibleUsers, setVisibleUsers] = useState<number>(6);
  const { theme } = useTheme();

  const handleShowMore = () => {
    setVisibleUsers((prev) => prev + 6);
  };

  const renderRankCircle = (index: number) => {
    if (index < 3) {
      return (
        <div
          className={`${styles.circle} ${
            theme === "dark" ? styles.darkTheme : ""
          } ${styles[`circle${index + 1}`]}`}
        >
          {index + 1}
        </div>
      );
    }
    return (
      <div
        className={`${styles.circle} ${
          theme === "dark" ? styles.darkTheme : ""
        } ${styles.circleWhite}`}
      >
        {index + 1}
      </div>
    );
  };

  return (
    <div
      className={`${styles.leaderboard} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      {isLoading ? (
        <CircleLoader colorType="dark" isLoading={isLoading} />
      ) : (
        <>
          <table className={styles.table}>
            <thead>
              <tr>
                <th
                  className={`${styles.th} ${styles.thNumber} ${
                    theme === "dark" ? styles.darkTheme : ""
                  }`}
                >
                  #
                </th>
                <th
                  className={`${styles.th} ${styles.thName} ${
                    theme === "dark" ? styles.darkTheme : ""
                  }`}
                >
                  Name
                </th>
                <th
                  className={`${styles.th} ${styles.thXp} ${
                    theme === "dark" ? styles.darkTheme : ""
                  }`}
                >
                  Karma Score
                </th>
              </tr>
            </thead>
            <tbody>
              {users.slice(0, visibleUsers).map((user, index) => (
                <tr key={user.address} className={styles.row}>
                  <td
                    className={`${styles.td} ${styles.tdNumber} ${
                      theme === "dark" ? styles.darkTheme : ""
                    }`}
                  >
                    {renderRankCircle(index)}
                  </td>
                  <td
                    className={`${styles.td} ${styles.tdName} ${
                      theme === "dark" ? styles.darkTheme : ""
                    }`}
                  >
                    {user.address}
                  </td>
                  <td
                    className={`${styles.td} ${styles.tdXp} ${
                      theme === "dark" ? styles.darkTheme : ""
                    }`}
                  >
                    {isRef ? user.ref_xp : user.xp_mul}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {visibleUsers < users.length && (
            <Button onClick={handleShowMore} className={styles.showMore}>
              View more
            </Button>
          )}
        </>
      )}
    </div>
  );
};

export default Leaderboard;
